<template>
  <!------------------------------------------
    An alert using the provided text and width.
  -------------------------------------------->
  <div class="alert-select-grantee">
    <v-alert class="alert-alert"
      dark
      type="info"
      :max-width="parseInt(maxWidth)"
      color="#5a5a5a"
    >
      {{ text }}           
    </v-alert>
  </div>
</template>

<script> 
export default {
  name: 'AlertSelectGrantee',
  props: {
    text: { type: String, required: true },
    maxWidth: { type: String, required: false }
  }
}
</script>

<style lang="scss">
.alert-select-grantee {
  margin: 0 auto 1rem auto;

  .alert-alert {
    margin: 0 auto;
  }
}

</style>


